module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/en-banner.742cf16b.png";